/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchInteractionEvent } from './SearchInteractionEvent';
import {
    SearchInteractionEventFromJSON,
    SearchInteractionEventFromJSONTyped,
    SearchInteractionEventToJSON,
    SearchInteractionEventToJSONTyped,
} from './SearchInteractionEvent';

/**
 * 
 * @export
 * @interface SearchInteractionBatchRequest
 */
export interface SearchInteractionBatchRequest {
    /**
     * 
     * @type {Array<SearchInteractionEvent>}
     * @memberof SearchInteractionBatchRequest
     */
    events: Array<SearchInteractionEvent>;
}

/**
 * Check if a given object implements the SearchInteractionBatchRequest interface.
 */
export function instanceOfSearchInteractionBatchRequest(value: object): value is SearchInteractionBatchRequest {
    if (!('events' in value) || value['events'] === undefined) return false;
    return true;
}

export function SearchInteractionBatchRequestFromJSON(json: any): SearchInteractionBatchRequest {
    return SearchInteractionBatchRequestFromJSONTyped(json, false);
}

export function SearchInteractionBatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchInteractionBatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(SearchInteractionEventFromJSON)),
    };
}

export function SearchInteractionBatchRequestToJSON(json: any): SearchInteractionBatchRequest {
    return SearchInteractionBatchRequestToJSONTyped(json, false);
}

export function SearchInteractionBatchRequestToJSONTyped(value?: SearchInteractionBatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'events': ((value['events'] as Array<any>).map(SearchInteractionEventToJSON)),
    };
}

